
import classNames from "classnames";
import { translate } from "react-i18next";
import * as React from "react";

import { TooltipBody } from "components";
import { DivTooltip, Menu } from "@wg/wows-react-uikit";

import styles from "./SeasonTypeDropdown.scss";
import { getLastSeason } from "helpers/ladder";
import { t } from "helpers/localization";
import { SEASON_TYPES } from "reducers/ReducerRatings";
import { getLastRegularSeason, getLastBrawlSeason } from '../../../helpers/ladder'

export type IProps = {
  selectedSeasonType: string;
  dropdownPosition?: string;
  displayIcons: Boolean;
  onSeasonTypeChange: () => void;
};

class SeasonTypeDropdown extends React.PureComponent<IProps> {

  constructor(props) {
    super(props);

    this.state = {
      isMenuActive: false
    };

    this.onItemChange = this.onItemChange.bind(this);
    this.onMenuBlur = this.onMenuBlur.bind(this);
    this.onMenuToggled = this.onMenuToggled.bind(this);
  }

  onItemChange(seasonType) {
    this.setState({
      isMenuActive: false
    });
    this.props.onSeasonTypeChange(seasonType);
  }

  onMenuBlur() {
    this.setState({
      isMenuActive: false
    });
  }

  onMenuToggled(isMenuActive) {
    this.setState({
      isMenuActive: isMenuActive
    });
  }

  _getItems(lastSeasonKind = SEASON_TYPES.REGULAR) {
    let modeList = [];
    if (getLastRegularSeason()){
      modeList.push({
        value: SEASON_TYPES.REGULAR,
        content: <span>{t('Клановые бои')}</span>
      })
    }
    if (getLastBrawlSeason()){
      modeList.push({
        value: SEASON_TYPES.BRAWL,
        content: <span>{t('Клановый блиц')}</span>
      })
    }
    return lastSeasonKind === SEASON_TYPES.REGULAR ? modeList : modeList.reverse();
  }

  render() {
    const lastSeason = getLastSeason();

    const selectedSeasonType = this.props.selectedSeasonType || lastSeason.kind;
    const seasonTypeList = this._getItems(lastSeason.kind);

    const labelStyles = {};
    labelStyles[styles.iconEnable] = this.props.displayIcons;
    labelStyles[selectedSeasonType === SEASON_TYPES.REGULAR ? styles.clanRegularModeLogo : styles.clanBrawlModeLogo] = true;

    const selectedItem = seasonTypeList.find(item => {
      return item.value === selectedSeasonType;
    });

    const label = <div className={classNames(styles.label, labelStyles)}>
                {selectedItem && selectedItem.content}
            </div>;

    // TODO: Add disabled parameter to DivTooltip
    const content = <Menu items={seasonTypeList} itemSelected={selectedSeasonType} onItemChange={this.onItemChange} onMenuBlur={this.onMenuBlur} onMenuToggled={this.onMenuToggled} dropdownPosition={this.props.dropdownPosition}>
                {this.state.isMenuActive ? label : <DivTooltip tooltipBody={<TooltipBody withMouseClick>
                                    {t('Выбрать тип  клановых боев для отображения')}
                                </TooltipBody>}>
                            {label}
                        </DivTooltip>}
            </Menu>;

    return <div className={styles.container}>{content}</div>;
  }
}

export default translate()(SeasonTypeDropdown);